import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchSetFilterQuery } from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import setFilterQuery from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";

type HandlerType = HandlerWithResult<ProductFilters, ProductFilters>;

export const DispatchSetFilterQueryEmpty: HandlerType = props => {
    // SetFilterQuery derives the complete query from Redux. Its optional
    // parameter is unused, so one path correctly handles both partial and
    // final filter removals while preserving non-filter query parameters.
    props.dispatch(setFilterQuery());
};

replaceInChain(chain, DispatchSetFilterQuery, DispatchSetFilterQueryEmpty);
